import React, { useEffect, useRef, useState } from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import PhoneImage from '@assets/manager-promotion1-phone.png';
import PhoneImageNoShadow2x from '@assets/manager-promotion1-phone-no-shadow-2x.png';
import PhoneImageNoShadow from '@assets/manager-promotion1-phone-no-shadow.png';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useTranslation } from 'react-i18next';
import { useScroll } from '@src/shared/hooks/use-scroll';
import { moveSmartPhoneImageAccordingtoScroll$Animation } from '../../shared/animations';
import useInViewport from '@shared/hooks/use-in-viewport';
const ManagerPromotionContent = () => {
  const classes = useStyles();
  const {isResolutionMobile} = useDeviceDetect()
  const {t} = useTranslation()
  const headerIconSize = isResolutionMobile ? 24 : 33
  const desktopModePhoneImageRef = useRef(null)
  const desktopModePhoneImage2Ref = useRef(null)
  const { scrollTop, scrolledPercentage } = useScroll()
  const desktopModePhoneImageIsInViewPort = useInViewport(desktopModePhoneImageRef)
  const desktopModePhoneImage2IsInViewPort = useInViewport(desktopModePhoneImage2Ref)


  useEffect(()=> {
    moveSmartPhoneImageAccordingtoScroll$Animation(desktopModePhoneImageRef.current, scrolledPercentage, desktopModePhoneImageIsInViewPort)
    moveSmartPhoneImageAccordingtoScroll$Animation(desktopModePhoneImage2Ref.current, scrolledPercentage, desktopModePhoneImage2IsInViewPort)
  },[scrollTop,desktopModePhoneImageIsInViewPort,desktopModePhoneImage2IsInViewPort])

  

  return (
    <div className={classes.managerPromotionContent}>
        <div className='managerpromotion-side-section-1'>
          <div className='title-holder'>
            <JetFontIcon
                className="title-icon"
                iconname={JET_FONTICON_ALIASES.HAND_HEART}
                size={headerIconSize}
                customstyle={{marginTop:`-${(headerIconSize / 2)}px`, height:`${headerIconSize}px`}}
              />
            <Typography  variant={`${isResolutionMobile ? 'h3' : 'h1'}`} className={`${isResolutionMobile ? 'heading_l' : 'heading_xxl'} managerpromotioncontent-title`} align={'left'}>
              {t('new_productoverview_manager.section6_title')}
            </Typography>
          </div>
          {isResolutionMobile && <img src={PhoneImage} className='phone-image-mobile-view' />}
          <Typography className="body_regular managerpromotioncontent-description" variant="body1" align="left">
            {t('new_productoverview_manager.section6_description')}
          </Typography>
          
      </div>
      {!isResolutionMobile && <div className="managerpromotion-side-section-2">
        <img className='original-image' src={PhoneImageNoShadow} ref={desktopModePhoneImageRef} />
        <img className='retina-image' src={PhoneImageNoShadow2x} ref={desktopModePhoneImage2Ref} />
      </div>}
    </div>
  );
};

export default ManagerPromotionContent;
